import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import Loader from '../../shared/components/Loader'

@inject('auth') @observer
class BasePage extends Component {

  static propTypes = {
    auth: PropTypes.object,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    type: PropTypes.string,
  }

  render() {

    const { type, auth, children } = this.props

    if (auth.error) {
      return children
    }

    // in case the user is not logged in, just render the children, no base container
    if (!auth.isLoggedIn) {
      return <Loader>Nutzer wird angemeldet...</Loader>
    }

    return (
      <div className="horizontal app-content">
        <div
          className={`vertical ${type}-layout`}
        >
          {children}
        </div>
      </div>
    )
  }
}

export { BasePage as default }



// WEBPACK FOOTER //
// ./src/base/components/BasePage.js